module.exports = __webpack_public_path__ + "static/img/Gallery05.91f3c9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery05.jpg
// module id = jlvw
// module chunks = 12